// extracted by mini-css-extract-plugin
var _1 = "SearchListItems-moduleSearchListItems__lxIzF";
var _2 = "SearchListItems-moduleitem__NIgf1 SearchListItem-moduleSearchListItem__g46Wx";
export { _1 as "SearchListItems", _2 as "item" }
